import Vue from 'vue'
import {
  loadCart,
  dealGoods,
  submitOrder,
  updateGoods
} from '@/fetch/shopping-cart/purchase'
import { SessionStorage } from '@/utils'
import { ResultCode } from '~const/ResultCode'
import { mapGetters, mapActions } from 'vuex'
import { getTheme } from '@/assets/styles/theme.js'
import {
  Toast, Dialog
} from 'vant'
Vue.use(Toast)
  .use(Dialog)
const validateHandler = {
  /**
   * @description 验证地址
   * @returns {boolean}
   */
  validateAddress () {
    const { _this } = this
    if (_this.cartInfo.address.length === 0) { // 验证地址
      Toast({
        duration: 1000,
        message: '您还没有收货地址哦，快去添加地址吧'
      })
      setTimeout(() => {
        SessionStorage.setItem('newAddress', '1')
        _this.$router.push('/receiver-address/add')
      }, 1000)
      return false
    }
    return true
  },
  /**
   * @description 非代客下单且非全款，提示商品定金不支持退款，同意后继续下单
   * @returns {boolean}
   */
  validatePresell () {
    const { _this } = this
    let presell = SessionStorage.getItem('presell')

    if (_this.isPresell && +presell.payment_type === 1) {
      Dialog.confirm({
        title: '',
        overlay: true,
        className: 'cart-dialog',
        showCancelButton: true,
        cancelButtonText: '再想想',
        confirmButtonText: '同意并下单',
        message: '预售商品定金不支持退款，同意后继续下单'
      }).then(async () => {
        await _this.$nextTick()
        this.next()
        // on close
      }).catch(() => {
        Dialog.close()
        // on cancel
      })
      return false
    }
    return true
  },
  /**
   * @description 验证发票
   * @returns {boolean}
   */
  validateInvoices () {
    const { _this } = this
    if (Array.isArray(_this.cartInfo.invoices) && +_this.cartInfo.invoices_setting_set === 0) { // 如果没发票信息拼接不强制开发票把type设置为0
      _this.cartInfo.invoices = {}
      _this.cartInfo.invoices.type = 0
      return true
    }
    if (!_this.cartInfo.invoices.type && +_this.cartInfo.invoices_setting_set === 1) { // 强制开发票但是未选中发票
      Toast('请填写发票')
      return false
    }
    return true
  },

  /**
   * @description  验证优惠券
   * @returns {boolean}
   */
  validateCoupon () {
    const { _this } = this
    if (!_this.isPresell && !validateHandler.hasUsable(_this) && _this.isFirstSubmitCoupon && _this.coupon.usable.length > 0) { // 首次提交检查是否有可用优惠券(预售商品不能使用优惠券)
      this._this.isFirstSubmitCoupon = false
      this._this.isCouponPopup = true
      return false
    }
    return true
  },

  /**
   * 判断有没有使用优惠券
   * @returns {boolean}
   */
  hasUsable (_this) {
    if (_this.coupon.usable.some(item => item.state === 3)) {
      return true
    }
    return false
  },

  /**
   * @description 验证是否存在全场促销或者优惠券与特价满赠有无共享情况
   * @returns {boolean}
   */
  validateNotshare () {
    const { _this } = this
    if (_this.isFirstSubmitNotshare && +_this.cartData.is_has_not_share_ident === 1) { // 首次提交检查是否存在全场促销或者优惠券与特价满赠有无共享情况
      this._this.isFirstSubmitNotshare = false
      Dialog.alert({
        title: '',
        overlay: true,
        message: '部分商品已参加特价、采满有赠促销活动，不再参与其他促销'
      }).then(async () => {
        await _this.$nextTick()
        this.next()
        // on close
      }).catch(() => {
        Dialog.close()
        // on cancel
      })
      return false
    }
    return true
  },

  /**
   * @description 工具fnc
   * @returns {boolean}
   */
  validateGoods (_this) {
    let selectGoods = _this.getSelectIdents.join().split(',')
    return _this.isOnlinePayGoods.some(ident => selectGoods.includes(ident))
  },

  /**
   * @description 验证特殊商品 含嘛碱
   * @returns {boolean}
   */
  validateSpecialGoods () {
    const { _this } = this
    if (validateHandler.validateGoods(_this) && _this.cartInfo.limit_online_pay_goods_set) { // 存在特殊商品  && 开启了麻黄碱商品仅限线上支付
      Dialog.confirm({
        title: '',
        overlay: true,
        className: 'cart-dialog',
        showCancelButton: true,
        cancelButtonText: '返回购物车',
        confirmButtonText: '继续支付',
        message: '您提交的订单中含有以下特殊商品，仅限在线支付，若要使用线下支付，请返回购物车重新选择'
      }).then(async () => {
        await _this.$nextTick()
        this.next()
        // on close
      }).catch(() => {
        Dialog.close()
        // on cancel
      })
      return false
    }
    return true
  },

  /**
   * @description 验证价格是否满足起送金额
   * @returns {boolean}
   */
  validateMoney () {
    const { _this } = this
    if (+_this.cartData.money < +_this.cartInfo.amount) { // 不满起送金额
      if (+_this.cartInfo.send_amount_set_val === 1) { // 不限制提交
        Dialog.confirm({
          title: '',
          overlay: true,
          className: 'cart-dialog',
          showCancelButton: true,
          cancelButtonText: '返回购物车',
          confirmButtonText: '继续支付',
          message: `请注意，您订单不满起送金额${_this.cartInfo.amount}元，可能被无理由弃单，是否仍要提交？`
        }).then(async () => {
          await _this.$nextTick()
          _this.sureSubmit()
          // on close
        }).catch(() => {
          Dialog.close()
          // on cancel
        })
      } else { // 配送金额限制  不能下单
        Dialog.alert({
          title: '',
          overlay: true,
          message: `请注意，您订单不满起送金额${_this.cartInfo.amount}元，不能提交订单`
        }).then(() => {
          Dialog.close()
          // on close
        })
      }
      return false
    }
    _this.sureSubmit()
  }
}

/**
 * 责任链模式  控制提交订单流程
 */
class Chain {
  constructor (fn, vm) {
    this.fn = fn
    this._this = vm
    this.sucessor = null
  }
  setNext (sucessor) {
    this.sucessor = sucessor
    return sucessor
  }
  /**
   * 方便验证订单里面的方法能够手动下一步
   */
  next () {
    this.sucessor.run.apply(this.sucessor, arguments)
  }
  run () {
    const result = this.fn.apply(this, arguments)
    if (result) {
      this.next()
    }
  }
}
export default {
  data () {
    return {
      cartData: null,
      prevClickIds: [],
      nextClickIds: [],
      errorData: [], // 失效商品
      showSkeleton: true,
      isLoading: false,
      disabled: false,
      isOnlinePayGoods: [], // 特殊商品
      remark: '',
      allIdents: [],
      coupon: {
        usable: [],
        unusable: []
      }
    }
  },
  computed: {
    ...mapGetters(['getSelectIdents', 'getReceiverAddress']),
    theme () {
      return getTheme()
    },
    isPresell () {
      return this.$route.path === '/shopping-cart/presell'
    }

  },
  methods: {
    ...mapActions(['SELECT_IDENTS', 'RECEIVER_ADDRESS', 'CART_GETNUM']),
    loadData () {
      // eslint-disable-next-line no-unused-expressions
     this.$refs.baseRef?.loadCartBaseData()
     this.loadCartData()
    },
    async postUpdateGoods (msg) {
      this.disabledClick = true
      await updateGoods(msg)
      await this.loadCartData(true)
      this.disabledClick = false
    },
    async deal (errorData) {
      const { status, data } = await dealGoods({ error: errorData })
      if (status === ResultCode.SUCCESS && data.del_img.length > 0) {
        this.isFailureGoodsPopup = true
        this.errorData = data.del_img
      } else {
        this.loadCartData()
      }
    },
    /**
     * @description 下拉刷新
     */
    async onRefresh () {
      this.isFirst = true
      this.isFirstSubmitCoupon = true
      this.isFirstSubmitNotshare = true
      this.loadData()
    },
    /**
     * @description 确保wrapScroll节点已经渲染
     */
    mountedHandler () {
      this.$nextTick(() => {
        if (this.$refs.wrapScroll) {
          this.$refs.wrapScroll.$el.onscroll = e => {
            if (e.target.scrollTop > 0) {
              this.disabled = true
            } else {
              this.disabled = false
            }
          }
        }
        if (this.$refs.suitRef?.[0]?.previousSibling?.lastChild) { // 去掉套装商品上一个的下划线
          this.$refs.suitRef[0].previousSibling.lastChild.lastChild.style.setProperty('border-bottom', 'none', 'important')
        }
      })
    },
    /**
     * 加载商品
     */
    async loadCartData (refresh = false) {
      let params = {
        time: Date.now(),
        // eslint-disable-next-line camelcase
        is_point: this.cartInfo?.points_open ? 1 : 0,
        prev_click_ids: this.prevClickIds.join(','),
        next_click_ids: this.nextClickIds.join(','),
        goods_id: '',
        presell_id: '',
        quantity: '',
        is_presell: '',
        payment_type: ''
      }
      if (refresh) {
        params.idents = this.getSelectIdents.join(',')
      }
      let presell = SessionStorage.getItem('presell')
      if (this.isPresell && presell) {
        params.goods_id = presell.goods_id
        params.presell_id = presell.presell_id
        params.quantity = presell.quantity
        params.is_presell = presell.is_presell
        params.payment_type = presell.payment_type
      }
      let res = await loadCart(params)
      this.showSkeleton = false
      this.isLoading = false
      if (res.state === ResultCode.SUCCESS) {
        this.CART_GETNUM({ rand: (new Date()).valueOf() })
        Toast.clear()
        /**
         * 这个第一次加载商品默认全部选中，把商品的ident以数组形式存到vuex，然后每个商品的选中未选中操作这这个数组的删除/添加就行
         * 比如删除操作把数组中的这个商品的ident去掉，添加就把商品的ident push进去
         * 例外就是套装是多个商品 需[ident1,ident2,ident3].join(',')之后再做删除或添加操作
         * */
        let data = res.data
        if (this.isFirst) {
          let selectedArr = [] // 用于存放选中商品的ident
          let allIdents = [] // 用于存放选中商品的ident
          const isOnlinePayGoods = []
          Object.keys(data).forEach(key => {
            let goodsList = data[key].goods_list
            let goodsListKeys = Object.keys(goodsList)
            goodsListKeys.length && goodsListKeys.forEach(i => {
              if (Array.isArray(goodsList[i]) || +i !== 3) { // 非套装
                goodsList[i].forEach(item => {
                  if (+item.is_can_select !== 0) {
                    selectedArr.push(item.ident)
                  }
                  allIdents.push(item.ident)
                  if (+item.is_online_pay_goods) { // 含嘛碱商品
                    isOnlinePayGoods.push(item.ident)
                  }
                  // isOnlinePayGoods
                })
              } else { // 套装
                let suitList = goodsList[i]
                let suitListKeys = Object.keys(goodsList[i])
                suitListKeys.forEach(k => { // 套装商品把ident拼接在一起
                  let idents = []
                  suitList[k].forEach(g => {
                    idents.push(g.ident)
                    if (+g.is_online_pay_goods) { // 含嘛碱商品
                      isOnlinePayGoods.push(g.ident)
                    }
                  })
                  allIdents.push(idents.join(','))
                  let hasSelect = suitList[k].every(item => {
                    return +item.is_can_select === 1
                  })
                  if (hasSelect) {
                    selectedArr.push(idents.join(','))
                  }
                })
              }
            })
          })
          this.allIdents = allIdents
          this.SELECT_IDENTS({ ident: selectedArr, isSelect: true })// 存到vuex
          this.idents = [...selectedArr]// 用于全选取消全选
          this.isOnlinePayGoods = isOnlinePayGoods
          this.isFirst = false
          this.mountedHandler()
        }
        if (!refresh) {
          this.cartData = JSON.parse(JSON.stringify(res))
        } else {
          /**
           * 勾选未勾选情况，后端只会返回勾选的商品及优惠信息
           * 所以需要拷贝除了商品列表之外的所有字段
           * 这一步骤用旧数据与新数据比较，然后更新旧数据
           *  */
          this.cartData = this.copyGoods(this.cartData, res)
        }
        this.resetPrice()
        this.coupon.usable = []
        this.coupon.unusable = []
        let joinCouponIds = res.discount_conpon.join_coupon_ids
        this.prevClickIds = this.nextClickIds = joinCouponIds ? joinCouponIds.split(',') : []
        res.discount_conpon.coupon_list.forEach(item => {
          if (+item.state >= 2) { // 可用优惠券
            if (item.state === 3) {
              this.$set(item, 'isSelect', true)
            } else {
              this.$set(item, 'isSelect', false)
            }
            this.coupon.usable.push(item)
          } else {
            this.coupon.unusable.push(item)
          }
        })
      } else if (res.state === 1) { // 商品错误处理
        this.errorHandler(res, params)
      }
    },
    /**
     * 商品错误处理
     */
    errorHandler (res, params) {
      Toast(res.msg)
      if (!this.isPresell) {
        setTimeout(() => {
          this.deal(res.data)
        }, 1500)
      } else {
        // 预售错误号处理
        if (res.data['35']) {
          if (res.data['error_detail']['35-info'][params.presell_id]['buy_num'] > 0) {
            this.reload('quantity', res.data['error_detail']['35-info'][params.presell_id]['buy_num'])
          } else {
            this.cartData = null
          }
        }
        if (res.data['6']) {
          this.reload('quantity', res.data['error_detail']['6-info'][params.presell_id]['buy_num'])
        }
        if (res.data['13']) {
          this.reload('quantity', res.data['13'][params.presell_id])
        }
        if (res.data['11']) {
          if (res.data['error_detail']['11-info'][params.presell_id]['buy_num'] > 0) {
            this.reload('quantity', res.data['error_detail']['11-info'][params.presell_id]['buy_num'])
          } else {
            this.cartData = null
          }
        }
      }
    },
    reload (key, value) {
      const presell = SessionStorage.getItem('presell')
      presell[key] = value
      SessionStorage.setItem('presell', presell)
      this.loadCartData()
    },
    async resetPrice () {
      const { cartData, getSelectIdents } = this
      await this.$nextTick()
      if (!getSelectIdents.length) {
        cartData.money = 0
        cartData.coupon_price = 0
        cartData.coupon_money_arr.total_money = 0
        cartData.coupon_money_arr.total_discount_coupon_money = 0
        cartData.coupon_money_arr.total_coupon_money = 0
        cartData.coupon_money_arr.point_coupon_money = 0
        cartData.coupon_money_arr.express_price = 0
      }
    },
    /**
     * @description 根据新数据 旧数据比较 把新数据的值更新到旧数据
     */
    copyGoods (oldData, newData) {
      let returnData = JSON.parse(JSON.stringify(oldData))
      returnData.coupon_money_arr = newData.coupon_money_arr
      returnData.coupon_price = newData.coupon_price
      returnData.discount_conpon = newData.discount_conpon
      returnData.is_has_not_share_ident = newData.is_has_not_share_ident
      returnData.money = newData.money
      returnData.run = newData.run
      returnData.state = newData.state
      // eslint-disable-next-line no-unused-vars
      for (const [key, value] of Object.entries(returnData.data)) {
        for (const [key2, value2] of Object.entries(value.goods_list)) {
          if (+key2 === 3) {
            // eslint-disable-next-line no-unused-vars
            for (const [key3, value3] of Object.entries(value2)) {
              for (const item of value3) {
                this.matchData(newData, item, value)
              }
            }
          } else {
            for (const item of value2) {
              this.matchData(newData, item, value)
            }
          }
        }
      }
      return returnData
    },
    matchData (newData, goods, promotion) {
      // eslint-disable-next-line no-unused-vars
      for (const [key, value] of Object.entries(newData.data)) {
        for (const [key2, value2] of Object.entries(value.goods_list)) {
          if (+key2 === 3) {
            // eslint-disable-next-line no-unused-vars
            for (const [key3, value3] of Object.entries(value2)) {
              for (const item of value3) {
                if (goods.ident === item.ident) {
                  goods.realPrice = item.realPrice
                  goods.singlePrice = item.singlePrice
                  goods.quantity = item.quantity
                  promotion.promotion_info = value.promotion_info
                }
              }
            }
          } else {
            for (const item of value2) {
              if (goods.ident === item.ident) {
                goods.realPrice = item.realPrice
                goods.quantity = item.quantity
                goods.deposit = item.deposit
                goods.last_amout = item.last_amout
                promotion.promotion_info = value.promotion_info
              }
            }
          }
        }
      }
    },
    /**
     * @deprecated 前端验证通过，确定提交
     */
    sureSubmit () {
      let presell = SessionStorage.getItem('presell')
      Dialog.confirm({
        title: '',
        overlay: true,
        message: '您确定要提交订单？'
      }).then(async () => {
        const params = {
          idents: this.getSelectIdents.join(),
          address_id: this.getReceiverAddress.id,
          is_point: this.cartInfo.points_open ? 1 : 0,
          is_select_invoice: this.cartInfo.invoices.type === 0 ? 0 : 1,
          next_click_ids: this.nextClickIds.join(','),
          order_note: this.remark
        }
        if (this.isPresell) {
          params.goods_id = presell.goods_id
          params.presell_mobile = presell.presell_mobile
          params.quantity = presell.quantity
          params.presell_id = presell.presell_id
          params.is_presell = presell.is_presell
        }
        const { data, info, status } = await submitOrder(params)
        if (status === ResultCode.SUCCESS) {
          window.location = '/order/success?order_number=' + data.order_number
        } else if (status === 1) {
          Toast(info.msg)
        } else if (status === 2) {
          this.deal(data)
        } else if (status === 3) {
          Dialog.alert({
            title: '',
            overlay: true,
            message: info.msg
          }).then(() => {
            window.location = '/order/success?order_number=' + data.order_number
          }).catch(() => {
            Dialog.close()
            // on cancel
          })
        }
      }).catch(() => {
        Dialog.close()
      })
    },
    /**
     * @description 提交订单
     */
    submitCart () {
      const {
        cartInfo,
        isPresell,
        getSelectIdents
      } = this
      if (+cartInfo.is_set_payment !== 1) {
        Toast('卖家未设置任何支付方式，请联系客服处理')
        return false
      }
      if (!getSelectIdents.length) {
        Toast('您还没选择商品哦')
      } else {
        if (isPresell) { // 预售
          if (+cartInfo.is_replace) {
            Toast('代客下单暂不允许购买预售商品')
            return false
          }
          this.validateOrder()
        } else { // 非预售
          this.validateOrder()
        }
      }
    },
    /**
   * @description 验证订单
   */
    validateOrder () {
      /**
       * 以下代码使用了 责任链模式  不清楚请百度了解下,也可以看下下面链接的demo
       * https://github.com/fellowT/note/issues/13
       */
      const chainObj = {}
      const handlerArr = [
        'validateAddress', // 验证地址
        'validatePresell', // 预售全款不支持退款
        'validateInvoices', // 验证发票
        'validateCoupon', // 验证优惠券
        'validateNotshare', // 验证是否存在全场促销或者优惠券与特价满赠有无共享情况
        'validateSpecialGoods', // 验证特殊商品
        'validateMoney'// 验证是否不满起送金额
      ]
      for (const fnc of handlerArr) { // 循环执行验证方法
        chainObj[fnc + 'Chain'] = new Chain(validateHandler[fnc], this) // 把this传进去，让验证订单的那些方法拿到当前组件实例
      }
      const {
        validateAddressChain,
        validatePresellChain,
        validateInvoicesChain,
        validateCouponChain,
        validateNotshareChain,
        validateSpecialGoodsChain,
        validateMoneyChain } = chainObj

      validateAddressChain
        .setNext(validatePresellChain)
        .setNext(validateInvoicesChain)
        .setNext(validateCouponChain)
        .setNext(validateNotshareChain)
        .setNext(validateSpecialGoodsChain)
        .setNext(validateMoneyChain)

      validateAddressChain.run()
      // this.sureSubmit()
    },
    getCartInfo (msg) {
      this.cartInfo = msg
    },
    /**
     * @description 验证选中的商品有么有特殊商品 含麻黄碱
     */
    validateGoods () {
      let selectGoods = this.getSelectIdents.join().split(',')
      return this.isOnlinePayGoods.some(ident => selectGoods.includes(ident))
    },
    validateAddress (address) {
      if (address.length === 0) {
        Toast({
          duration: 500,
          message: '您还没有收货地址哦，快去添加地址吧'
        })
        setTimeout(() => {
          this.$router.push('/receiver-address?path=/shopping-cart/purchase')
        }, 500)
        return false
      }
      return true
    }
  }
}
